import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationprojectCycleConstants {
    static URL = UrlConstants.API_V2 + "PropertyValuationProjectCycle";
    static FUNCTION_DELETE_MULTIPLE_GENERAL_VALUATION_RUNS = "DeleteMultipleprojectCycles";
    static FUNCTION_SET_PARAMETER = "SetParameter";
    static FUNCTION_CHECK_FOR_EXISTING_SURVEYS = "checkForExistingSurveys";
    static FUNCTION_SAVE_PROJECT_CYCLE_ATTACHMENT = "SaveProjectCycleAttachment";
}
